import { Button, HStack, Input, Text, Stack } from "@chakra-ui/react";
import { VStack } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";

const EventNameStep = () => {
  const {
    register,
    watch,
    setValue,
    resetField,
    formState: { defaultValues },
  } = useFormContext();
  const name = watch("name");
  const subtitle = watch("subtitle");

  return (
    <VStack w="full" spacing={8} py={4}>
      <Stack spacing={1} w="full">
        <HStack w="full" justifyContent={"flex-start"}>
          <Text w="full" fontWeight={"medium"}>
            Event Name
          </Text>
          <Button
            hidden={name === defaultValues.name}
            variant={"link"}
            fontSize={"xs"}
            color={"gray.500"}
            flexShrink={0}
            cursor={"pointer"}
            onClick={() => {
              setValue("name", defaultValues.name);
            }}
          >
            Revert to saved
          </Button>
        </HStack>
        <Input
          size="md"
          placeholder="Event Name"
          value={name}
          {...register("name")}
        />
      </Stack>
      <Stack spacing={1} w="full">
        <HStack w="full" justifyContent={"flex-start"}>
          <Stack spacing={0}>
            <HStack justifyContent={"space-between"} w="full">
              <HStack>
                <Text fontWeight={"medium"}>Event Subtitle</Text>
                <Text fontWeight={"400"}>(Optional)</Text>
              </HStack>
              {/* <Button
                hidden={subtitle === defaultValues.subtitle}
                variant={"link"}
                fontSize={"xs"}
                color={"gray.500"}
                cursor={"pointer"}
                onClick={() => {
                  setValue("subtitle", defaultValues.subtitle);
                }}
              >
                Revert to saved
              </Button> */}
            </HStack>

            <Text fontSize={"sm"} color={"gray.500"}>
              Shown below the event name
            </Text>
          </Stack>
        </HStack>
        <Input
          size="md"
          placeholder="Event Subtitle"
          value={subtitle}
          {...register("subtitle")}
        />
      </Stack>
    </VStack>
  );
};

export default EventNameStep;
